import React from 'react';

import { Button, Modal } from 'antd';
import { AssociationsSelector } from 'ui-library';
import { getTranslatedString } from 'helpers/i18n';

const AssociationsEditModal = ({ visible, handleClose, dataSource, onSelection, selectedRows }) => {
  const handleClickCancel = () => {
    handleClose();
  };

  return (
    <Modal
      width={900}
      visible={visible}
      title={getTranslatedString('landlordPortal.applicationPackages.form.editAssociations')}
      onCancel={handleClickCancel}
      footer={[
        <Button key="back" onClick={handleClickCancel}>
          {getTranslatedString('cancel')}
        </Button>,
        <Button key="submit" type="primary" onClick={handleClose}>
          {getTranslatedString('save')}
        </Button>,
      ]}
    >
      <AssociationsSelector
        cancelAction={() => {}}
        loading={dataSource.length === 0}
        dataSource={dataSource}
        saveAction={() => {}}
        onSelection={onSelection}
        selectedRows={selectedRows}
        showExactMatchCheckbox
        asyncSave
      />
    </Modal>
  );
};

export default AssociationsEditModal;
